import 'i18n/config'
import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {
 LayoutProvider,
 LayoutSplashScreen,
} from 'layout/master-layout'

const App = () => {
 return (
  <Suspense fallback={<LayoutSplashScreen />}>
   {/* provide the core layout settings, classes, variables, attr and other things */}
   <LayoutProvider>
    {/* <p>Working app.tsx</p> */}
    <Outlet />
   </LayoutProvider>
  </Suspense>
 )
}

export {App}
